export const EMPTY_ENVIRONMENT_STATS = Object.freeze({
  total: null, running: null, stopped: null, creating: null, stopping: null, error: null, unknown: null,
  available: false, observedAt: null,
});

export const countLabel = value => Number.isFinite(value) ? value : '—';
export const environmentStateLabel = state => ({ running: 'Running', creating: 'Starting',
  stopping: 'Stopping', stopped: 'Stopped', error: 'Error', unknown: 'Unknown' }[state] || 'Unknown');

export function sumRunning(labs) {
  return labs.every(lab => Number.isFinite(lab.containerStats?.running))
    ? labs.reduce((sum, lab) => sum + lab.containerStats.running, 0) : null;
}

export function withEnvironmentStats(lab, inventory) {
  const next = inventory?.byLab?.[lab.id];
  // All count surfaces use the shared query, including during HTTP failures.
  // Metadata can refresh independently but must not introduce competing totals.
  return { ...lab, containerStats: next || EMPTY_ENVIRONMENT_STATS };
}

export function statsTreeLabs(inventory) {
  return Object.values(inventory?.byLab || {}).map(stats => ({
    id: stats.labId, name: stats.labName, term: stats.term, courseCode: stats.courseCode,
    section: stats.section, labNumber: stats.labNumber, isSemesterLab: stats.isSemesterLab,
    activityType: stats.activityType, activityNumber: stats.activityNumber,
    customActivityType: stats.customActivityType, activityLabel: stats.activityLabel, nameSuffix: stats.nameSuffix,
    status: stats.status, studentCount: stats.studentCount, containerStats: stats,
  }));
}
